import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AudienciaService } from "../../services/audiencia-service";
import { ProcessoService } from "../../services/processo-service";
import { ToastrService } from "ngx-toastr";
import { Audiencia } from "../../models/audiencia";
import Swal from "sweetalert2";

@Component({
    selector: 'app-detalhes',
    templateUrl: './detalhes.component.html',
    styleUrl: './detalhes.component.css',
    standalone: false
})
export class DetalhesComponent {
  @Output() atualizarLista = new EventEmitter();
  @Input() telaProcesso = false;
  @Input() isModalDetalhes = false;
  modalDetalhes = false;
  loading = false;
  audiencia = new Audiencia();
  listaProcessos: any[] = [];
  botaoSalvarLocal = false;
  dataAudiencia: string;
  horaAudiencia: string;

  getStatusDescricao(status: number): string {
    switch (status) {
      case 0: return 'Agendada';
      case 1: return 'Realizada';
      case 2: return 'Cancelada';
      default: return '—';
    }
  }

  get podeExibirAcoes(): boolean {
    return this.audiencia?.status === 0;
  }

  constructor(private audienciaService: AudienciaService,
              private processoService: ProcessoService,
              private toastr: ToastrService) {
  }

  showModalDetalhes() {
    this.modalDetalhes = true;
    this.loading = true;
  }

  abrirModal(id: number) {
    this.showModalDetalhes();
    this.listarProcessos();
    this.buscarDados(id);
  }

  fecharModal() {
    this.modalDetalhes = false;
    this.audiencia = new Audiencia();
  }

  listarProcessos() {
    this.processoService.selecionarLista().subscribe((response: any) => {
      if (response.sucesso) {
        this.listaProcessos = response.dados.itens;
      }
    });
  }

  buscarDados(id: number) {
    this.loading = true;
    this.audienciaService.selecionarPorId(id).subscribe((response: any) => {
      if (response.sucesso) {
        this.audiencia = response.dados;
        if (this.audiencia?.dataInicio) {
          const dataHora = this.audiencia.dataInicio.split('T');
          this.dataAudiencia = dataHora[0];
          if (dataHora[1]) {
            this.horaAudiencia = dataHora[1].substring(0, 5);
          }
        }
      } else {
        this.toastr.error("Erro ao carregar dados da audiência");
        this.fecharModal();
      }
      this.loading = false;
    }, (error: any) => {
      this.toastr.error("Erro ao carregar dados da audiência");
      this.fecharModal();
      this.loading = false;
    });
  }

  salvar() {
    this.loading = true;
    if (this.dataAudiencia && this.horaAudiencia) {
      this.audiencia.dataInicio = `${this.dataAudiencia}T${this.horaAudiencia}:00.000Z`;
    }

    this.audienciaService.alterar(this.audiencia).subscribe(
      (response) => {
        if (response.sucesso) {
          this.toastr.success("Audiência atualizada com sucesso");
          this.buscarDados(this.audiencia.id);
          this.botaoSalvarLocal = false;
        } else {
          this.toastr.error("Erro ao atualizar audiência");
        }
        this.loading = false;
      },
      (error) => {
        this.toastr.error("Erro ao atualizar audiência");
        this.loading = false;
      }
    );
  }

  excluir() {
    Swal.fire({
      title: 'Deseja realmente excluir esta audiência?',
      text: "Esta ação não poderá ser revertida!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir',
      confirmButtonColor: '#d33',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.audienciaService.excluir(this.audiencia.id).subscribe(
          (response) => {
            if (response.sucesso) {
              this.toastr.success("Audiência excluída com sucesso");
              this.fecharModal();
              this.atualizarLista.emit();
            } else {
              this.toastr.error("Erro ao excluir audiência");
            }
            this.loading = false;
          },
          (error) => {
            this.toastr.error("Erro ao excluir audiência");
            this.loading = false;
          }
        );
      }
    });
  }

  cancelarAudiencia() {
    Swal.fire({
      title: 'Deseja realmente cancelar esta audiência?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, cancelar',
      confirmButtonColor: '#d33',
      cancelButtonText: 'Voltar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.audienciaService.cancelar(this.audiencia.id).subscribe((response: any) => {
          if (response.sucesso) {
            this.toastr.success("Audiência cancelada");
            this.buscarDados(this.audiencia.id);
            this.atualizarLista.emit();
          }
          this.loading = false;
        }, (error: any) => {
          this.toastr.error("Erro ao cancelar audiência");
          this.loading = false;
        });
      }
    });
  }

  finalizarAudiencia() {
    Swal.fire({
      title: 'Deseja finalizar esta audiência?',
      icon: 'success',
      showCancelButton: true,
      confirmButtonText: 'Sim, finalizar',
      confirmButtonColor: '#28a745',
      cancelButtonText: 'Voltar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.audienciaService.finalizar(this.audiencia.id).subscribe((response: any) => {
          if (response.sucesso) {
            this.toastr.success("Audiência finalizada");
            this.buscarDados(this.audiencia.id);
            this.atualizarLista.emit();
          }
          this.loading = false;
        }, (error: any) => {
          this.toastr.error("Erro ao finalizar audiência");
          this.loading = false;
        });
      }
    });
  }

  cancelar() {
    this.botaoSalvarLocal = false;
    this.buscarDados(this.audiencia.id);
  }
}
